import React from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowLeft, Trash2 } from "lucide-react";
import { PRODUCTS } from "../data";
import ProductCard from "../components/ProductCard";
import useWishlist from "../useWishlist";

export default function Wishlist({ onAdd, onBuyNow }) {
  const wishlist = useWishlist();
  const items = PRODUCTS.filter((p) => wishlist.has(p.id));

  return (
    <div data-testid="wishlist-page" className="relative">
      <span className="stamp-num absolute top-6 right-6 md:right-12">N° W</span>

      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-12 md:pt-16 pb-14">
        <p className="section-num">
          <strong>·</strong> Wishlist
        </p>
        <div className="grid md:grid-cols-12 gap-10 items-end mt-5">
          <h1 className="md:col-span-8 font-display text-display-lg text-ink tracking-tightest fade-up">
            Saved for
            <br />
            <span className="font-italic text-coral">a fresher day.</span>
          </h1>
          <p className="md:col-span-4 text-ink/60 max-w-md text-[15px] leading-relaxed fade-up-d1">
            Tap the heart on any product to save it here. We'll let you know
            when it's back in season or on offer.
          </p>
        </div>
      </section>

      {items.length === 0 ? (
        <section className="max-w-3xl mx-auto px-6 py-24 text-center">
          <div className="mx-auto h-20 w-20 rounded-full bg-sageMist grid place-items-center">
            <Heart className="h-7 w-7 text-sageDeep" />
          </div>
          <h2 className="font-display text-display-md text-ink mt-8 tracking-tightest">
            No favourites yet.
          </h2>
          <p className="text-ink/60 mt-4 max-w-md mx-auto">
            Wander into the shop and heart anything you'd like to come back to.
          </p>
          <Link to="/shop" className="btn-primary mt-10 inline-flex">
            <ArrowLeft className="h-4 w-4" /> Browse the shop
            <span className="knob">→</span>
          </Link>
        </section>
      ) : (
        <section className="max-w-7xl mx-auto px-6 md:px-12 pb-32">
          <div className="flex items-center justify-between mb-8">
            <p className="text-[12px] uppercase tracking-[0.22em] text-muted">
              <span className="text-coral font-medium tabular-nums">{items.length}</span> saved
              {items.length === 1 ? " item" : " items"}
            </p>
            <button
              data-testid="wishlist-clear"
              onClick={wishlist.clear}
              className="inline-flex items-center gap-2 text-xs text-muted hover:text-coral transition-colors"
            >
              <Trash2 className="h-3.5 w-3.5" /> Clear all
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {items.map((p, idx) => (
              <ProductCard
                key={p.id}
                product={p}
                onAdd={onAdd}
                onBuyNow={onBuyNow}
                index={idx}
                total={items.length}
              />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
